module.exports = __webpack_public_path__ + "img/integration-module-3.518e6463.png";